import { useRef, useEffect, useState } from "react";
import ReactCodeInput from "react-code-input";
import { AuthWrapper, BackLink, Box, Description, RowCode, Title, Wrapper } from "../style"
import { Button } from "shared/components/Button";
import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { showNotification } from "shared/redux/slice/notificationSlice";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { detectLoginType } from "shared/utils/detectLoginType";
import { formatPhoneNumber } from "shared/utils/formatPhoneNumber";

interface IPropsConfirmCodeForm {
    setIsConfirm: (value: boolean) => void;
    setCode: (code: string) => void;
    login: string;
}

export const ConfirmCodeForm = ({ setIsConfirm, setCode, login }: IPropsConfirmCodeForm) => {
    const inputRef = useRef<any>(null)
    const [codeError, setCodeError] = useState<string>("");

    const dispatch = useDispatch();

    const mutation = useMutation({
        mutationFn: ({ code }: { code: string }) => {
            return axios.post(`${process.env.API_OAUTH}/v1/user/recovery_password`, {
                login: login,
                code: code
            });
        },
        onError: (error: any) => {
            setCodeError("");
            if (error?.response?.status === 400 || error?.response?.status === 422) {
                setCodeError("Неверный код подтверждения");
            } else {
                setCodeError("Произошла ошибка при проверке кода");
            }
            
            dispatch(showNotification({
                message: "Вы ввели не верный код!",
                type: "error",
            }));
        },
        onSuccess: (_, variables) => {
            setCodeError("");
            
            dispatch(showNotification({
                message: "Код подтвержден!",
                type: "success",
            }));
            setCode(variables.code)
        }
    })

    useEffect(() => {
        if (null !== inputRef.current){
            document.querySelectorAll("input").forEach((node: HTMLInputElement) => node.setAttribute('placeholder', '0'));
        }
    }, [])

    const formik = useFormik({
        initialValues: {
            code: "",
        },
        validationSchema: Yup.object({
            code: Yup.string()
                .required("Введите код")
                .matches(/^\d{6}$/, "Код должен состоять из 6 цифр"),
            }),
        onSubmit: (values) => {
            setCodeError("");
            
            mutation.mutate({
                code: values.code
            })
        }
    })

    const getCodeError = () => {
        if (formik.errors.code) {
            return formik.errors.code;
        }
        if (codeError) {
            return codeError;
        }
        return "";
    }

    return (
        <AuthWrapper>
            <Box>
                <Wrapper onSubmit={formik.handleSubmit}>
                    <Title>Подтвердите вход</Title>
                    <Description>
                        Введите код, который
                        {detectLoginType(login) === "email" && ` пришел на почту ${login}` }
                        {detectLoginType(login) === "phone" && ` отправлен на номер телефона ${formatPhoneNumber(login)}`}
                        {detectLoginType(login) === "login" && ` отправлен на почту или телефон для указанного пользователя ${login}`}
                    </Description>
                    <RowCode>
                        <ReactCodeInput 
                            ref={inputRef} 
                            placeholder="0" 
                            type='number' 
                            fields={6} 
                            name="code" 
                            inputMode="numeric"
                            onChange={(val: string) => {
                                formik.setFieldValue("code", val);
                                if (codeError) {
                                    setCodeError("");
                                }
                            }}
                        />
                    </RowCode>
                    {getCodeError() && (
                        <div style={{ 
                            color: '#ff4d4f', 
                            fontSize: '14px', 
                            marginTop: '8px',
                            textAlign: 'center'
                        }}>
                            {getCodeError()}
                        </div>
                    )}
                    <Button 
                        themeType="primary" 
                        disabled={mutation.isPending}
                    >
                        {mutation.isPending ? "Проверка..." : "Подтвердить"}
                    </Button>
                    <BackLink onClick={() => setIsConfirm(false)}>Назад</BackLink>
                </Wrapper>
            </Box>
        </AuthWrapper>
    )
}